import {ContentSection, Skeleton, Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

export function BuyerAssetContentSkeleton() {
  const {t} = useTranslation('trustAccounts');
  const paymentHeaderKeys = [
    'payment-col-date',
    'payment-col-method',
    'payment-col-amount',
    'payment-col-percent',
    'payment-col-reference',
    'payment-col-status'
  ];
  const paymentRowKeys = ['payment-row-1', 'payment-row-2', 'payment-row-3'];
  const documentHeaderKeys = [
    'doc-col-file',
    'doc-col-type',
    'doc-col-size',
    'doc-col-last-updated',
    'doc-col-upload-date',
    'doc-col-actions'
  ];
  const documentRowKeys = ['doc-row-1', 'doc-row-2'];

  return (
    <div className="flex flex-col gap-6">
      {/* Asset heading */}
      <div className="flex items-center gap-2">
        <Skeleton className="size-8 rounded-lg" />
        <Skeleton className="h-7 w-32" />
      </div>

      {/* Metrics card */}
      <div className="grid grid-cols-4 gap-6 rounded-xl border border-border-subtle p-6 shadow-xs">
        {[
          t('view.buyers.detail.metrics.purchasePrice'),
          t('view.buyers.detail.metrics.maxCollection'),
          t('view.buyers.detail.metrics.paymentRequestsSent'),
          t('view.buyers.detail.metrics.completedPayments')
        ].map(label => (
          <div key={label} className="flex flex-col gap-2">
            <Typography size="xs" color="tertiary">
              {label}
            </Typography>
            <Skeleton className="h-6 w-24" />
            <Skeleton className="mt-1 h-2 w-full rounded-full" />
          </div>
        ))}
      </div>

      <ContentSection title={t('view.buyers.detail.paymentHistory')}>
        <div className="overflow-hidden rounded-xl border border-border-subtle shadow-xs">
          <div className="grid grid-cols-6 gap-4 border-b border-border-subtle bg-background-surface px-4 py-3">
            {paymentHeaderKeys.map(headerKey => (
              <Skeleton key={headerKey} className="h-3 w-20" />
            ))}
          </div>
          {paymentRowKeys.map(rowKey => (
            <div
              key={rowKey}
              className="grid grid-cols-6 items-center gap-4 border-b border-border-subtle px-4 py-3 last:border-b-0"
            >
              <div className="flex flex-col gap-1">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-3 w-14" />
              </div>
              <Skeleton className="h-5 w-24 rounded-full" />
              <Skeleton className="h-4 w-16" />
              <Skeleton className="h-4 w-12" />
              <Skeleton className="h-5 w-20 rounded-md" />
              <Skeleton className="h-5 w-20 rounded-full" />
            </div>
          ))}
        </div>
      </ContentSection>

      <ContentSection
        title={t('view.purchases.documents')}
        action={<Skeleton className="h-9 w-28 rounded-md" />}
      >
        <div className="overflow-hidden rounded-xl border border-border-subtle shadow-xs">
          <div className="grid grid-cols-6 gap-4 border-b border-border-subtle bg-background-surface px-4 py-3">
            {documentHeaderKeys.map(headerKey => (
              <Skeleton key={headerKey} className="h-3 w-16" />
            ))}
          </div>
          {documentRowKeys.map(rowKey => (
            <div
              key={rowKey}
              className="grid grid-cols-6 items-center gap-4 border-b border-border-subtle px-4 py-3 last:border-b-0"
            >
              <div className="flex items-center gap-3">
                <Skeleton className="size-8 shrink-0 rounded" />
                <Skeleton className="h-4 w-32" />
              </div>
              <Skeleton className="h-5 w-20 rounded-full" />
              <Skeleton className="h-4 w-10" />
              <Skeleton className="h-4 w-16" />
              <Skeleton className="h-4 w-16" />
              <div className="flex items-center justify-end gap-1">
                <Skeleton className="size-7 rounded" />
                <Skeleton className="size-7 rounded" />
                <Skeleton className="size-7 rounded" />
              </div>
            </div>
          ))}
        </div>
      </ContentSection>
    </div>
  );
}
